<template>
  <div
    v-if="store.getters.userId != ''"
    class="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 py-8 px-3"
  >
    <!-- Hero Section -->
    <div class="max-w-4xl mx-auto mb-6">
      <div class="text-center mb-6">
        <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          የሚከራይ
          <span
            class="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
            >ንብረት ይለጥፉ</span
          >
        </h1>
        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
          ንብረትዎን ቀለል ባለ መንገድ ያከራዩ።
          <span class="text-red-500" style="font-size: 15px">
            <br />
            ልብ በሉ: ደላላ አናስተናግድም!
          </span>
        </p>
      </div>
    </div>

    <!-- Form Container -->
    <div class="max-w-4xl mx-auto">
      <div class="bg-white rounded-3xl shadow-2xl overflow-hidden">
        <!-- Form Header -->
        <div class="bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-6">
          <div class="flex items-center space-x-3 justify-between">
            <div>
              <h2 class="text-2xl font-bold text-white">አዲስ የሚከራይ ልጥፍ</h2>
              <p class="text-blue-100">ለመጀመር ከታች ያለውን ዝርዝር ይሙሉ</p>
            </div>
            <div
              @click="
                $router
                  .push({
                    name: 'myrental',
                  })
                  .catch((err) => {})
              "
              class="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center"
            >
              <svg
                class="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 20l-5-2V6l5 2 5-2 5 2v12l-5-2-5 2zM9 2v2m6-2v2"
                />
              </svg>
            </div>
          </div>
        </div>

        <!-- Form Content -->
        <div class="p-8 md:p-10">
          <form @submit.prevent="submit" class="space-y-8">
            <!-- Basic Information Section -->
            <div class="space-y-4">
              <div class="flex items-center space-x-3 mb-4">
                <div
                  class="w-6 h-6 bg-blue-100 rounded-lg flex items-center justify-center"
                >
                  <svg
                    class="w-3 h-3 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900">መሰረታዊ መረጃ</h3>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <!-- Title -->
                <div class="space-y-1">
                  <label class="block text-sm font-medium text-gray-700"
                    >Item Title | መጠርያ ስም
                    <span class="text-red-500">*</span></label
                  >
                  <div class="relative">
                    <input
                      v-model="form.title"
                      type="text"
                      placeholder="ርዕስ ያስገቡ(ለምሳሌ የሚከራይ መኖርያ ቤት)"
                      @blur="validateField('title')"
                      class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      :class="
                        errors.title
                          ? 'border-red-300 bg-red-50 focus:ring-red-500'
                          : 'border-gray-300 hover:border-gray-400'
                      "
                    />
                    <div
                      v-if="errors.title"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <svg
                        class="h-4 w-4 text-red-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <p
                    v-if="errors.title"
                    class="text-red-600 text-xs flex items-center space-x-1"
                  >
                    <svg
                      class="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <span>{{ errors.title }}</span>
                  </p>
                </div>

                <!-- Price -->
                <div class="space-y-1">
                  <label class="block text-sm font-medium text-gray-700">
                    Price | ዋጋ <span class="text-red-500">*</span></label
                  >
                  <div class="relative">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <span class="text-gray-500 text-sm">$</span>
                    </div>
                    <input
                      v-model.number="form.price"
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="0.00"
                      @blur="validateField('price')"
                      class="w-full pl-7 pr-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      :class="
                        errors.price
                          ? 'border-red-300 bg-red-50 focus:ring-red-500'
                          : 'border-gray-300 hover:border-gray-400'
                      "
                    />
                  </div>
                  <p
                    v-if="errors.price"
                    class="text-red-600 text-xs flex items-center space-x-1"
                  >
                    <svg
                      class="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <span>{{ errors.price }}</span>
                  </p>
                </div>

                <!-- Phone -->
                <div class="space-y-1">
                  <label class="block text-sm font-medium text-gray-700"
                    >Contact Phone | ስልክ ቁጥር
                    <span class="text-red-500">*</span></label
                  >
                  <div class="relative">
                    <input
                      v-model="form.phone"
                      type="tel"
                      placeholder="ስልክ ቁጥር ያስገቡ"
                      @blur="validateField('phone')"
                      class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      :class="
                        errors.phone
                          ? 'border-red-300 bg-red-50 focus:ring-red-500'
                          : 'border-gray-300 hover:border-gray-400'
                      "
                    />
                  </div>
                  <p
                    v-if="errors.phone"
                    class="text-red-600 text-xs flex items-center space-x-1"
                  >
                    <svg
                      class="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <span>{{ errors.phone }}</span>
                  </p>
                </div>
              </div>

              <!-- Address -->
              <div class="space-y-1">
                <label class="block text-sm font-medium text-gray-700"
                  >Location | አድራሻ <span class="text-red-500">*</span></label
                >
                <div class="relative">
                  <input
                    v-model="form.address"
                    type="text"
                    placeholder="አድራሻ ያስገቡ"
                    @blur="validateField('address')"
                    class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    :class="
                      errors.address
                        ? 'border-red-300 bg-red-50 focus:ring-red-500'
                        : 'border-gray-300 hover:border-gray-400'
                    "
                  />
                </div>
                <p
                  v-if="errors.address"
                  class="text-red-600 text-xs flex items-center space-x-1"
                >
                  <svg
                    class="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  <span>{{ errors.address }}</span>
                </p>
              </div>

              <!-- Description -->
              <div class="space-y-1">
                <label class="block text-sm font-medium text-gray-700"
                  >Description | ዝርዝር መግለጫ
                  <span class="text-red-500">*</span></label
                >
                <div class="relative">
                  <textarea
                    v-model="form.description"
                    rows="3"
                    placeholder="ማንኛውንም አስፈላጊ ዝርዝሮችን ይግለጹ..."
                    @blur="validateField('description')"
                    class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none"
                    :class="
                      errors.description
                        ? 'border-red-300 bg-red-50 focus:ring-red-500'
                        : 'border-gray-300 hover:border-gray-400'
                    "
                  ></textarea>
                </div>
                <p
                  v-if="errors.description"
                  class="text-red-600 text-xs flex items-center space-x-1"
                >
                  <svg
                    class="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  <span>{{ errors.description }}</span>
                </p>
              </div>
            </div>

            <!-- Media Upload Section -->
            <div class="space-y-4">
              <div class="flex items-center space-x-3 mb-3">
                <div
                  class="w-6 h-6 bg-green-100 rounded-lg flex items-center justify-center"
                >
                  <svg
                    class="w-3 h-3 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    ></path>
                  </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900">
                  Video & Photo | ቪዲዮ እና ፎቶ
                </h3>
              </div>

              <!-- Images Upload -->
              <div class="space-y-3">
                <div class="flex items-center justify-between">
                  <label class="block text-sm font-medium text-gray-700"
                    >የንብረቱ ፎቶ ያስገቡ<span class="text-red-500">*</span></label
                  >
                  <!-- <span class="text-xs text-gray-500">እስከ 10 ፎቶዎችን ይጨምሩ።</span> -->
                </div>
                <input
                  ref="imageInput"
                  type="file"
                  @change="handleImages"
                  accept="image/*"
                  multiple
                  class="hidden"
                />

                <!-- Horizontal Scrolling Container for Images -->
                <div class="overflow-x-auto pb-2">
                  <div class="flex space-x-3 min-w-max">
                    <!-- Image Previews -->
                    <div
                      v-for="(img, idx) in imagePreviews"
                      :key="idx"
                      class="relative group flex-shrink-0 w-32 h-20 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-all duration-200"
                    >
                      <img
                        :src="img"
                        class="w-full h-full object-contain bg-gray-50"
                      />
                      <div
                        class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center"
                      >
                        <div
                          class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1"
                        >
                          <button
                            type="button"
                            @click="replaceImage(idx)"
                            class="p-1.5 bg-white bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                          >
                            <svg
                              class="w-3 h-3 text-gray-700"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                              ></path>
                            </svg>
                          </button>
                          <button
                            type="button"
                            @click.stop="removeImage(idx)"
                            class="p-1.5 bg-red-500 bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                          >
                            <svg
                              class="w-3 h-3 text-white"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Add Image Button -->
                    <div
                      v-if="imagePreviews.length < 10"
                      class="flex-shrink-0 w-32 h-20 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 group"
                      @click="triggerImageFile"
                    >
                      <svg
                        class="w-6 h-6 text-gray-400 group-hover:text-blue-500 transition-colors duration-200"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        ></path>
                      </svg>
                      <span
                        class="text-xs text-gray-500 group-hover:text-blue-600 mt-1 text-center"
                        >ፎቶ ይጨምሩ</span
                      >
                    </div>
                  </div>
                </div>

                <p
                  v-if="errors.images"
                  class="text-red-600 text-xs flex items-center space-x-1"
                >
                  <svg
                    class="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  <span>{{ errors.images }}</span>
                </p>
              </div>

              <!-- Videos Upload (Optional) -->
              <div class="space-y-3">
                <div class="flex items-center justify-between">
                  <label class="block text-sm font-medium text-gray-700">
                    አጭር ቪዲዮ (መተው ይቻላል)</label
                  >
                  <span class="text-xs text-gray-500">እስከ 30 ሴኮንድ</span>
                </div>
                <input
                  ref="videoInput"
                  type="file"
                  @change="handleVideos"
                  accept="video/*"
                  multiple
                  class="hidden"
                />

                <!-- Horizontal Scrolling Container for Videos -->
                <div class="overflow-x-auto pb-2">
                  <div class="flex space-x-3 min-w-max">
                    <!-- Video Previews -->
                    <div
                      v-for="(vid, idx) in videoPreviews"
                      :key="idx"
                      class="relative group flex-shrink-0 w-32 h-20 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-all duration-200"
                    >
                      <video
                        :src="vid"
                        class="w-full h-full object-contain bg-gray-50"
                        controls
                      ></video>
                      <div
                        class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center pointer-events-none"
                      >
                        <div
                          class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1 pointer-events-auto"
                        >
                          <button
                            type="button"
                            @click="replaceVideo(idx)"
                            class="p-1.5 bg-white bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                          >
                            <svg
                              class="w-3 h-3 text-gray-700"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                              ></path>
                            </svg>
                          </button>
                          <button
                            type="button"
                            @click.stop="removeVideo(idx)"
                            class="p-1.5 bg-red-500 bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                          >
                            <svg
                              class="w-3 h-3 text-white"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Add Video Button -->
                    <div
                      v-if="videoPreviews.length < 3"
                      class="flex-shrink-0 w-32 h-20 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 group"
                      @click="triggerVideoFile"
                    >
                      <svg
                        class="w-6 h-6 text-gray-400 group-hover:text-blue-500 transition-colors duration-200"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                        ></path>
                      </svg>
                      <span
                        class="text-xs text-gray-500 group-hover:text-blue-600 mt-1 text-center"
                        >ቪዲዮ ይጨምሩ</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="pt-4 border-t border-gray-200">
              <!-- Success Message -->
              <div
                v-if="showSuccess"
                class="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center space-x-3 animate-fade-in"
              >
                <div
                  class="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center"
                >
                  <svg
                    class="w-4 h-4 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h4 class="text-green-800 font-semibold text-sm">
                    በተሳካ ሁኔታ ተልኳል!
                  </h4>
                  <!-- <p class="text-green-600 text-xs">
                    አድሚኖች እስኪያጸድቁት ድረስ ትንሽ ይጠብቁ
                  </p> -->
                </div>
              </div>

              <div class="flex flex-col sm:flex-row gap-3">
                <!-- <button type="button" :disabled="isSubmitting" class="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-sm">
                  Save as Draft
                </button> -->
                <button
                  type="submit"
                  :disabled="isSubmitting"
                  class="flex-1 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold py-2.5 px-4 rounded-lg shadow-lg hover:from-blue-600 hover:to-purple-700 hover:shadow-xl transition-all duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                >
                  <!-- Loading Spinner -->
                  <svg
                    v-if="isSubmitting"
                    class="w-4 h-4 animate-spin"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    ></path>
                  </svg>
                  <!-- Success Icon -->
                  <svg
                    v-else-if="showSuccess"
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <!-- Default Icon -->
                  <svg
                    v-else
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    ></path>
                  </svg>
                  <span>{{
                    isSubmitting ? "እየላከ ነው..." : showSuccess ? "ተልኳል" : "ይለጥፉ"
                  }}</span>
                </button>
              </div>
              <p class="text-xs text-gray-500 text-center mt-2">
                በመለጠፍዎ
                <a
                  href="#"
                  class="text-blue-600 hover:text-blue-700"
                  @click.prevent="openLegal('terms')"
                  >የአገልግሎት ውል</a
                >
                እና
                <a
                  href="#"
                  class="text-blue-600 hover:text-blue-700"
                  @click.prevent="openLegal('privacy')"
                  >የግላዊነት ፖሊሲ</a
                >
                ተስማምተዋል።
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Legal Modal (Terms & Privacy) -->
    <transition name="fade">
      <div
        v-if="showLegalModal"
        class="fixed inset-0 z-50 flex items-center justify-center"
        aria-modal="true"
        role="dialog"
      >
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-gray-900 bg-opacity-50 backdrop-blur-sm"
          @click="closeLegal"
        ></div>

        <!-- Modal Panel -->
        <div
          class="relative w-11/12 max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden animate-fade-in"
        >
          <!-- Header -->
          <div class="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-5">
            <div class="flex items-center justify-between">
              <h3 class="text-white text-lg font-semibold">
                {{
                  activeLegalTab === "terms"
                    ? "Terms of Service"
                    : "Privacy Policy"
                }}
              </h3>
              <button
                class="w-9 h-9 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition"
                @click="closeLegal"
                aria-label="Close"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <!-- Tabs -->
            <div class="mt-4 inline-flex p-1 bg-white/20 rounded-xl">
              <button
                class="px-3 py-1.5 text-sm rounded-lg transition"
                :class="
                  activeLegalTab === 'terms'
                    ? 'bg-white text-blue-700 shadow'
                    : 'text-white/80 hover:text-white'
                "
                @click="activeLegalTab = 'terms'"
              >
                Terms
              </button>
              <button
                class="ml-1 px-3 py-1.5 text-sm rounded-lg transition"
                :class="
                  activeLegalTab === 'privacy'
                    ? 'bg-white text-purple-700 shadow'
                    : 'text-white/80 hover:text-white'
                "
                @click="activeLegalTab = 'privacy'"
              >
                Privacy
              </button>
            </div>
          </div>

          <!-- Body -->
          <div class="px-6 py-5 max-h-[70vh] overflow-y-auto text-gray-700">
            <!-- Terms Content -->
            <div v-if="activeLegalTab === 'terms'" class="space-y-4">
              <h4 class="text-gray-900 font-semibold">Terms of Service</h4>
              <p>
                This rental platform operates on a
                <span class="font-semibold">no-brokers</span> model. We connect
                owners and renters directly. By accessing or using the service,
                you agree to these terms.
              </p>
              <ul class="list-disc pl-5 space-y-2 text-sm">
                <li>
                  You must provide accurate and truthful information in listings
                  and your profile.
                </li>
                <li>
                  Uploaded photos/videos and descriptions must be lawful and
                  owned or licensed by you.
                </li>
                <li>
                  Verify all property details before publishing; you are
                  responsible for your content.
                </li>
                <li>
                  Prices and payments are arranged directly between owner and
                  renter; we do not collect brokerage fees.
                </li>
                <li>You must be at least 18 years old to use this service.</li>
                <li>
                  We may remove content or suspend accounts that violate these
                  terms or applicable laws.
                </li>
                <li>
                  The service is provided “as is”; we are not a party to rental
                  agreements between users.
                </li>
              </ul>
              <p class="text-sm text-gray-600">
                By using this platform you agree to follow our community,
                safety, and content guidelines.
              </p>
            </div>

            <!-- Privacy Content -->
            <div v-else class="space-y-4">
              <h4 class="text-gray-900 font-semibold">Privacy Policy</h4>
              <p>
                We respect your privacy. We collect and process only what we
                need to operate a broker-free rental system and keep users safe.
              </p>
              <div class="space-y-2 text-sm">
                <p class="font-medium">Data we collect:</p>
                <ul class="list-disc pl-5 space-y-1">
                  <li>Phone number</li>
                  <li>Username</li>
                  <li>Telegram ID (tg id)</li>
                </ul>
              </div>
              <div class="space-y-2 text-sm">
                <p class="font-medium">How we use it:</p>
                <ul class="list-disc pl-5 space-y-1">
                  <li>To manage listings you publish</li>
                  <li>To connect renters and owners directly</li>
                  <li>For security, fraud prevention, and abuse detection</li>
                </ul>
              </div>
              <div class="space-y-2 text-sm">
                <p class="font-medium">Sharing:</p>
                <p>
                  We do not sell your data. We do not share it with third
                  parties except when required by law or with your explicit
                  consent.
                </p>
              </div>
              <div class="space-y-2 text-sm">
                <p class="font-medium">Retention & Security:</p>
                <p>
                  We store data securely and retain it only as long as necessary
                  for the purposes above and to meet legal obligations.
                </p>
              </div>
              <div class="space-y-2 text-sm">
                <p class="font-medium">Your choices:</p>
                <p>
                  You may request access, correction, or deletion of your data,
                  subject to legal requirements.
                </p>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div
            class="px-6 py-4 bg-gray-50 flex items-center justify-end space-x-2"
          >
            <button
              class="px-4 py-2 text-sm rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
              @click="closeLegal"
            >
              Close
            </button>
            <button
              class="px-4 py-2 text-sm rounded-lg text-white bg-gradient-to-r from-blue-600 to-purple-600 shadow hover:from-blue-700 hover:to-purple-700 transition"
              @click="closeLegal"
            >
              I Understand
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";

import axios from "axios";
import { useMutation } from "@vue/apollo-composable";
import { gql } from "@apollo/client/core";
import { toast } from "@/toast";

const router = useRouter();

const ADD_RENTAL = gql`
  mutation AddRental($input: RentalInput!) {
    addRental(input: $input) {
      rent_id
      title
    }
  }
`;

const { mutate: addRental } = useMutation(ADD_RENTAL);
let cloudinaryUrl = [];
let videoUrl = [];

const submit = async () => {
  // Validate all fields
  ["title", "address", "phone", "price", "description"].forEach((f) =>
    validateField(f)
  );
  errors.videos = "";
  errors.images = "";

  if (Object.values(errors).some((e) => e !== "")) return;

  // Set loading state
  isSubmitting.value = true;
  for (let i = 0; i < form.images.length; i++) {
    cloudinaryUrl.push(await uploadImage(form.images[i]));
  }

  for (let i = 0; i < form.videos.length; i++) {
    videoUrl.push(await uploadImage(form.videos[i]));
  }

  cloudinaryUrl = cloudinaryUrl.length > 0 ? cloudinaryUrl.toString() : "";
  videoUrl = videoUrl.length > 0 ? videoUrl.toString() : "";

  addRental({
    input: {
      title: form.title,
      address: form.address,
      price: parseFloat(form.price),
      phone: form.phone,
      description: form.description.toString().trim().replace(/\n/g, "\\n"),
      images: cloudinaryUrl,
      videos: videoUrl,
      user_id: store.getters.userId,
    },
  });

  try {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 2000));

    // Show success state
    showSuccess.value = true;
    setTimeout(() => {
      showSuccess.value = false;
      // Reset form
      Object.keys(form).forEach((key) => {
        if (Array.isArray(form[key])) {
          form[key] = [];
        } else {
          form[key] = "";
        }
      });
      imagePreviews.value = [];
      videoPreviews.value = [];
      router
        .push({
          name: "myrental",
        })
        .catch((err) => {
          console.log(err);
        });
    }, 2000);
  } catch (error) {
    console.error("Error submitting form:", error);
  } finally {
    isSubmitting.value = false;
  }
};

const form = reactive({
  title: "",
  address: "",
  price: "",
  phone: "",
  description: "",

  images: [],
  videos: [],
});
const errors = reactive({
  title: "",
  address: "",
  price: "",
  phone: "",
  description: "",

  images: "",
  videos: "",
});
const domainUrl = "https://bdr.desalegntentprduction.com";

const imagePreviews = ref([]);
const videoPreviews = ref([]);
const imageInput = ref(null);
const videoInput = ref(null);
let replaceImageIndex = ref(null);
let replaceVideoIndex = ref(null);

// Loading and UI states
const isSubmitting = ref(false);
const showSuccess = ref(false);

// Legal modal state
const showLegalModal = ref(false);
const activeLegalTab = ref("terms");

function openLegal(tab) {
  activeLegalTab.value = tab;
  showLegalModal.value = true;
}
function closeLegal() {
  showLegalModal.value = false;
}

const regex = {
  title: /^.{1,100}$/,
  address: /^.{1,150}$/,
  phone: /^\+?\d{7,15}$/,
  price: /^[0-9]+$/,

  description: /^.{1,500}$/s,
};

function validateField(field) {
  switch (field) {
    case "title":
      errors.title = regex.title.test(form.title)
        ? ""
        : "ርዕስ ከ1-100 ፊደሎች መሆን አለበት።";
      break;
    case "address":
      errors.address = regex.address.test(form.address)
        ? ""
        : "አድራሻ ከ1-150 ፊደሎች መሆን አለበት።";
      break;
    case "phone":
      errors.phone = regex.phone.test(form.phone) ? "" : "ስልክ ቁጥር ልክ አደለም";
      break;
    case "price":
      errors.price = regex.price.test(form.price) ? "" : "ያስገቡት ዋጋ ትክክል አይደለም";
      break;

    case "description":
      errors.description = regex.description.test(form.description)
        ? ""
        : "መግለጫ ከ1-1000 ፊደሎች መሆን አለበት።";
      break;
    case "images":
      errors.images = "";
      break;
    case "videos":
      errors.videos = "";
      break;
  }
}

function triggerImageFile() {
  imageInput.value.click();
}
function triggerVideoFile() {
  videoInput.value.click();
}

function handleImages(e) {
  const files = Array.from(e.target.files);
  if (replaceImageIndex.value !== null) {
    const idx = replaceImageIndex.value;
    form.images[idx] = files[0];
    const r = new FileReader();
    r.onload = (ev) => (imagePreviews.value[idx] = ev.target.result);
    r.readAsDataURL(files[0]);
    replaceImageIndex.value = null;
  } else {
    files.forEach((f) => {
      form.images.push(f);
      const r = new FileReader();
      r.onload = (ev) => imagePreviews.value.push(ev.target.result);
      r.readAsDataURL(f);
    });
  }
  validateField("images");
}
function replaceImage(idx) {
  replaceImageIndex.value = idx;
  triggerImageFile();
}
function removeImage(idx) {
  form.images.splice(idx, 1);
  imagePreviews.value.splice(idx, 1);
  validateField("images");
}

function handleVideos(e) {
  const files = Array.from(e.target.files);
  if (replaceVideoIndex.value !== null) {
    const idx = replaceVideoIndex.value;
    form.videos[idx] = files[0];
    const r = new FileReader();
    r.onload = (ev) => (videoPreviews.value[idx] = ev.target.result);
    r.readAsDataURL(files[0]);
    replaceVideoIndex.value = null;
  } else {
    files.forEach((f) => {
      form.videos.push(f);
      const r = new FileReader();
      r.onload = (ev) => videoPreviews.value.push(ev.target.result);
      r.readAsDataURL(f);
    });
  }
}
function replaceVideo(idx) {
  replaceVideoIndex.value = idx;
  triggerVideoFile();
}
function removeVideo(idx) {
  form.videos.splice(idx, 1);
  videoPreviews.value.splice(idx, 1);
}

// async function submitForm() {
//   // Validate all fields
//   [
//     "title",
//     "address",
//     "phone",
//     "price",
//     "type",
//     "description",
//     "images",
//   ].forEach((f) => validateField(f));
//   errors.videos = "";

//   // if (Object.values(errors).some((e) => e !== "")) return;

//   // Set loading state
//   isSubmitting.value = true;
//   for (let i = 0; i < form.images.length; i++) {
//     cloudinaryUrl.push(await uploadImage(form.images[i]));
//   }

//   for (let i = 0; i < form.videos.length; i++) {
//     videoUrl.push(await uploadImage(form.videos[i]));
//   }

//   const { mutate: addRental } = useMutation(ADD_RENTAL);

//   alert("Adding rental...");
//   try {
//     const { data } = await addRental({
//       input: {
//         title: "House",
//         address: "123 St",
//         price: 1000,
//         phone: "555-555",
//         description: "Nice house",
//         type: "Apartment",
//         images: "",
//         videos: "",
//       },
//     });
//     console.log("✅ Success:", data.addRental);
//   } catch (err) {
//     console.error("❌ Error:", err.message);
//   }

//   try {
//     // Simulate API call
//     await new Promise((resolve) => setTimeout(resolve, 2000));

//     console.log("Form ready to send:", form);

//     // Show success state
//     showSuccess.value = true;
//     setTimeout(() => {
//       showSuccess.value = false;
//       // Reset form
//       Object.keys(form).forEach((key) => {
//         if (Array.isArray(form[key])) {
//           form[key] = [];
//         } else {
//           form[key] = "";
//         }
//       });
//       imagePreviews.value = [];
//       videoPreviews.value = [];
//     }, 3000);
//   } catch (error) {
//     console.error("Error submitting form:", error);
//   } finally {
//     isSubmitting.value = false;
//   }
// }

async function uploadImage(fileToUpload) {
  const formData = new FormData();
  formData.append("file", fileToUpload);

  try {
    const response = await axios.post(`${domainUrl}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return domainUrl + response.data.filePath;
  } catch (error) {
    toast.error("Error uploading image: " + error);
  }
}

// async function getUser() {
//   if (window.Telegram.WebApp) {
//       await window.Telegram.WebApp.ready();

//       const user = await window.Telegram.WebApp.initDataUnsafe.user;
//     let  param1 = await window.Telegram.WebApp.initDataUnsafe.start_param;
//       // param1 = params.get("postId");
//       // this.tg_id = user.id.toString();
//       // this.tg_username = user.username || "No Username";
//       store.dispatch("setUserId", user.id.toString());
//       if (param1 != null && param1 != "null" && param1 != "") {
//         store.dispatch("setUserId", "6160879304");

//       }

//       await window.Telegram.WebApp.expand();
//       // await window.Telegram.WebApp.enableClosingConfirmation();
//       // await window.Telegram.WebApp.disableVerticalSwipes();
//       // await window.Telegram.WebApp.setHeaderColor("#000000");
//       // await window.Telegram.WebApp.setBottomBarColor("#000000");
//       // await this.login();
//     } else {
//       store.dispatch("setUserId", "6160879304");
//     }

// }
</script>
